import { clsx } from 'clsx';
import React from 'react'
import Loader from "react-loader-spinner";

const GhostButton = ({ loading, disabled, className, children, ...rest }) => {
  return (
    <div className='w-72 h-12 mx-auto flex flex-row justify-center items-center px-5 py-2.5 me-2 mb-2'>
      {loading ? (
        <Loader
          type="Oval"
          visible={true}
          color="#0083ff"
          width={24}
          height={24}
          className="flex flex-1 justify-center items-center"
        />
      ) : (
        <button
          {...rest}
          type='button'
          disabled={disabled || loading}
          className={clsx(
            "text-green-primary text-lg font-bold",
            disabled && "cursor-default",
            !disabled && "cursor-pointer underline"
          )}
        >
            {children}
        </button>
      )}
    </div>
  )
}

export default GhostButton